import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { API } from '@/constants/api';
import { Question } from 'easyship-components/icons';
import { twMerge } from 'tailwind-merge';
import { LearnMoreProps } from './types';

function LearnMore({ sectionName, supportLink = '#', className }: LearnMoreProps) {
  const { formatMessage } = useIntl();
  const linkLabel = formatMessage({ id: sectionName, defaultMessage: sectionName });
  return (
    <div
      className={twMerge('text-ink-900 flex flex-row justify-start gap-2 items-center', className)}
    >
      <Question className="bg-white text-center w-[24px] h-[24px] rounded-full" />
      <div className="whitespace-nowrap">
        <FormattedMessage id="learn-more.content" />
        &nbsp;
        <a
          href={supportLink === '#' ? supportLink : API.help + supportLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkLabel}
        </a>
      </div>
    </div>
  );
}

export default LearnMore;
